<template>
  <div class="list">
    <v-app-bar
      fixed
      color="grey lighten-4"
      dense
      flat
    >
      <v-btn
        icon
        :to="($i18n.locale == 'en') ? '/en' : '/'"
      >
        <v-icon color="primary">mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>{{ $t('List.title') }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <!--<Information></Information>-->
      <ImportSheet @set-sheets="getSheets()"></ImportSheet>

    </v-app-bar>

    <p class="page-message" v-if="showPageMessage">{{ $t('List.firstMessage') }}</p>

    <v-container
      px-0
      pt-10
      style="padding-bottom: 168px;"
    >
      <ListItems :sheets="sheets" @set-sheets="getSheets()"></ListItems>
    </v-container>

    <CreateSheet :sheets="sheets" @set-sheets="getSheets()">
    </CreateSheet>

  </div>
</template>

<script>
import common from '@/mixins/common'
import db from '@/mixins/db'

import ListItems from '@/components/ListItems'
import CreateSheet from '@/components/CreateSheet'
import ImportSheet from '@/components/ImportSheet'
// import Information from '@/components/Information'

export default {
  metaInfo: {
    title: 'ポジショニングマップ一覧'
  },
  mixins: [common, db],
  components: {
    ListItems,
    CreateSheet,
    ImportSheet
    // Information
  },
  data () {
    return {
      sheets: [],
      importDialog: false,
      showPageMessage: false
    }
  },
  methods: {
    // -------- DB利用 --------
    getSheets () {
      this.openDb(() => {
        const store = this.startTransaction('readonly')
        const req = store.openCursor(null, 'prev')
        const sheets = []
        req.onsuccess = (e) => {
          const cursor = e.target.result
          if (cursor) {
            sheets.push({
              no: cursor.value.no,
              name: cursor.value.name
            })
            cursor.continue()
          }
          this.sheets = sheets
          this.showPageMessage = (sheets.length === 0)
        }
        req.onerror = (e) => {
          alert('[getSheets openDb Error] Sorry, application error.')
          return false
        }
      })
    }
    // -------- /DB利用 --------
  },
  created () {
    this.getSheets()
  },
  mounted () {
  }
}
</script>
